export interface SalesTeamInternalApiInterface {
  foreign_keys?: {
    partner_id: string;
    market_id: string;
  };
  group_id?: string;
  name?: string;
  updated?: Date;
}

export class SalesTeamInterface {
  partnerId?: string;
  marketId?: string;
  groupId?: string;
  teamName: string;
  updated?: Date;
}

export class SalesTeam implements SalesTeamInterface {
  partnerId: string;
  marketId: string;
  groupId: string;
  teamName: string;
  updated: Date;

  constructor(group: SalesTeamInterface) {
    this.partnerId = group.partnerId;
    this.marketId = group.marketId;
    this.groupId = group.groupId;
    this.teamName = group.teamName;
    this.updated = group.updated;
  }

  public static fromApi(data: SalesTeamInternalApiInterface): SalesTeam {
    return new SalesTeam({
      partnerId: data.foreign_keys.partner_id,
      marketId: data.foreign_keys.market_id,
      groupId: data.group_id,
      teamName: data.name,
      updated: data.updated,
    });
  }

  public static sortSalesTeamsAlphabetically(salesTeams: SalesTeam[]): SalesTeam[] {
    return salesTeams.sort((a, b) => {
      const aName = a.teamName.toLowerCase(),
        bName = b.teamName.toLowerCase();
      return aName < bName ? -1 : 1;
    });
  }
}

export type SalesTeamId = string;
